import React, { useState, useEffect } from 'react';
import {
  formatPrice,
  LoadingGrid,
  KTSVG,
  formatDateMonth,
  SimpleAlert,
} from '../../../../../_mexablock/helpers';
import { Filter } from '../../../pagos/pagados/components/Filter';
import { AprovisionarModal } from '../_modals/AprovisionarModal';
import { AprovisionamientoModal } from '../_modals/AprovisionarAccionModal';
import { CommentsModal } from '../_modals/ComentariosAprovisionar';
import { ComprobanteModal } from '../_modals/comprobante';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { useGetAll } from '../hooks/CuentasHook';
import { MenuComponent } from '../../../../../_mexablock/assets/ts/components';
import { downloadPDF } from '../../../../service/operacion/Cuentas';
import { parseAxiosError } from '../../../../service/reportes/AccountStatment';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [loadingDownload, setloadingDownload] = useState<boolean>(false);
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [visivilityModalSupplies, setVisivilityModalSupplies] = useState(false);
  const [visivilityModalComments, setVisivilityModalComments] = useState(false);
  const [visivilityModalComprobante, setVisivilityModalComprobante] =
    useState(false);
  const [voucherModal, setVoucherModal] = useState('');

  const [commetsModal, setcommetsModal] = useState('');
  const [dataSelected, setDataSelected] = useState({
    balance: 0,
    new_balance: 0,
    new_balance2: 0,
    account_number: '',
    company: {},
    distributor: {},
    account_id: 0,
    comments: '',
    comision: '',
  });

  const [dataTipoPago, setDataTipoPago] = useState<any>([]);
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('');
  const [initFilterValues, setInitFilterValues] = useState({
    init_date: '',
    end_date: '',
    search: '',
  });
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);
  useEffect(() => {
    if (loadingRequest > 0) {
      setDataTipoPago(data);
      setloadingView(false);
    }
  }, [loadingRequest]);

  // Disparar recarga cuando cambien los filtros
  useEffect(() => {
    if (initFilterValues.init_date || initFilterValues.end_date || initFilterValues.search) {
      setReloadGrid(Math.random() * 40);
    }
  }, [initFilterValues.init_date, initFilterValues.end_date, initFilterValues.search]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const regex = /^[a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑ.-]*$/;

    if (regex.test(value)) {
      setInputValue(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchFilter(inputValue);
      setInitFilterValues((prev) => ({ ...prev, search: inputValue }));
    }
  };

  const handleFilter = (values: any) => {
    setInitFilterValues((prev) => ({
      ...prev,
      init_date: values.init_date,
      end_date: values.end_date,
    }));
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      init_date: '',
      end_date: '',
      search: '',
    });
    setInputValue('');
    setSearchFilter('');
    setReloadGrid(Math.random() * 40);
  };

  const infoComments = (comment: string) => {
    setReloadGrid(Math.random() * 40);
    setcommetsModal(comment);
    setVisivilityModalComments(true);
  };

  const infoComprobante = (voucher: string) => {
    setReloadGrid(Math.random() * 40);
    setVoucherModal(voucher);
    setVisivilityModalComprobante(true);
  };

  const handleDownloadPDF = (routePdf: string) => {
    setloadingDownload(true);
    setTimeout(() => {
      downloadPDF(routePdf)
        .then(() => {
          setloadingDownload(false);
        })
        .catch(async (error) => {
          setloadingDownload(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  const columns: any = [
    {
      id: 'created_at',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.created_at),
      sortable: true,
      width: '150px',
    },
    {
      id: 'paymentType.name',
      name: <div className="fw-bolder text-muted me-5">Tipo Aprov.</div>,
      selector: (row: any) =>
        Number(row?.consignment) === 0 ? 'Venta directa' : 'Consignación',
      sortable: true,
      width: '150px',
    },
    {
      id: 'virtual',
      name: <div className="fw-bolder text-muted me-5">Monto Aprov.</div>,
      selector: (row: any) => Number(row.virtual || 0),
      cell: (row: any) => (
        <span className={'text-gray-700 fw-bolder'}>
          {formatPrice(row.virtual, 'es-MX', 'MXN', 2, 2)}
        </span>
      ),
      sortable: true,
      sortFunction: (a: any, b: any) =>
        Number(a.virtual || 0) - Number(b.virtual || 0),
      width: '150px',
    },
    {
      id: 'commssion',
      name: <div className="fw-bolder text-muted me-5">Comisión</div>,
      selector: (row: any) => Number(row.commission || 0),
      cell: (row: any) => (
        <span className={'text-gray-700 fw-bolder'}>
          {formatPrice(row.commission, 'es-MX', 'MXN', 2, 2)}
        </span>
      ),
      sortable: true,
      sortFunction: (a: any, b: any) =>
        Number(a.commission || 0) - Number(b.commission || 0),
      width: '150px',
    },
    {
      id: 'business_name',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => row?.to?.company?.name || '',

      sortable: true,
      width: '150px',
    },
    {
      id: 'paymentType',
      name: <div className="fw-bolder text-muted me-5">Mtdo. de pago</div>,
      selector: (row: any) =>
        row?.paymentType?.name ? row.paymentType.name : 'N/A',
      sortable: true,
      width: '150px',
    },
    {
      id: 'creator',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) => row.creator.first_name,
      cell: (row: any) => (
        <span className="fw-normal">
          {row.creator.first_name} {row.creator.father_last_name}
        </span>
      ),
      sortable: true,
      width: '200px',
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5"></div>,
      cell: (row: any) => dropdownRender(row),
      sortable: false,
      width: '200px',
    },
  ];

  const dropdownRender = (row: any) => {
    const hasVoucher = Boolean(row?.voucher);
    const hasNotas = Boolean(row?.notas);

    return (
      <div className="d-flex justify-content-end flex-shrink-0">
        <a
          href="#/"
          data-kt-menu="true"
          className="btn btn-light btn-active-light-primary btn-sm"
          data-kt-menu-trigger="click"
          data-kt-menu-placement="bottom-end"
        >
          Acciones
          <span className="svg-icon svg-icon-5 m-0">{/* icon */}</span>
        </a>

        <div
          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
          data-kt-menu="true"
        >
          {/* Ver comentario */}
          {/* <div className="menu-item px-3">
            <a
              className={`menu-link px-3 ${
                !hasNotas ? 'disabled text-gray-400' : ''
              }`}
              onClick={(e) => {
                if (!hasNotas) {
                  e.preventDefault();
                  return;
                }
                infoComments(row.notas);
              }}
            >
              Ver comentario
            </a>
          </div> */}

          {/* Ver comprobante */}
          <div className="menu-item px-3">
            <a
              className={`menu-link px-3 ${!hasVoucher ? 'disabled text-gray-400' : ''
                }`}
              onClick={(e) => {
                if (!hasVoucher) {
                  e.preventDefault();
                  return;
                }
                handleDownloadPDF(row.voucher);
              }}
            >
              Descargar
            </a>
          </div>
        </div>
      </div>
    );
  };

  const editRegister = (row: any) => {
    setDataSelected({
      balance: row.virtual_balance,
      new_balance: 0,
      new_balance2: 0,
      account_number: row.account_number,
      company: row.company,
      distributor: row.distributor,
      account_id: row.id,
      comments: '',
      comision: row.typeCommission.code,
    });
    setVisivilityModal(!visivilityModal);
  };

  const addSupply = (row: any) => {
    setVisivilityModalSupplies(!visivilityModalSupplies);
  };

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <div className="d-flex align-items-center gap-4">
                <Filter
                  initFilterValues={initFilterValues}
                  onCleanFilter={handleFilterClean}
                  onSearchFilter={handleFilter}
                />
                <div className="d-flex align-items-center position-relative me-4">
                  <span className="position-absolute ms-3" style={{ zIndex: 10 }}>
                    <i className="bi bi-search fs-4 text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control form-control-solid ps-9"
                    placeholder="Cliente"
                    maxLength={50}
                    value={inputValue}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo registro"
              >
                <a
                  href="#/"
                  className="btn btn-sm btn-light-primary"
                  id="kt_toolbar_primary_button"
                  onClick={addSupply}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Aprovisionar
                </a>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <AprovisionarModal
        data={dataSelected}
        show={visivilityModal}
        dataPago={dataTipoPago}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setDataSelected({
            balance: 0,
            new_balance: 0,
            new_balance2: 0,
            account_number: '',
            company: {},
            distributor: {},
            account_id: 0,
            comments: '',
            comision: '',
          });
          setVisivilityModal(!visivilityModal);
        }}
      ></AprovisionarModal>
      <AprovisionamientoModal
        show={visivilityModalSupplies}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setDataSelected({
            balance: 0,
            new_balance: 0,
            new_balance2: 0,
            account_number: '',
            company: {},
            distributor: {},
            account_id: 0,
            comments: '',
            comision: '',
          });
          setVisivilityModalSupplies(!visivilityModalSupplies);
        }}
      ></AprovisionamientoModal>

      <CommentsModal
        show={visivilityModalComments}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setVisivilityModalComments(!visivilityModalComments);
          }
        }}
        note={commetsModal}
      />
      <ComprobanteModal
        show={visivilityModalComprobante}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setVisivilityModalComprobante(!visivilityModalComprobante);
          }
        }}
        archivo={voucherModal}
      />
    </>
  );
};

export { View };
